import { cn } from "@/lib/utils"
import { Loader2 } from "lucide-react"
import type { ReactNode } from "react"

/**
 * A button label a spinner can stand in for without resizing the button
 * (TUR-1680). While `busy`, the label keeps its box in the layout and its
 * place in the button's accessible name but is not painted, and the spinner
 * sits centred over it. A spinner placed BESIDE the label widened the button
 * mid-press and moved everything next to it.
 */
export function BusyLabel({
  busy,
  children,
}: {
  busy: boolean
  children: ReactNode
}) {
  return (
    <span className="relative inline-flex items-center justify-center">
      <span className={cn(busy && "opacity-0")}>{children}</span>
      {busy && (
        <Loader2
          size={13}
          aria-hidden="true"
          className="absolute inset-0 m-auto animate-spin"
        />
      )}
    </span>
  )
}
